import React, { useEffect, useState } from "react";
import "./HospitalityV2Track.scss"
import { getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES } from "../../../../RestaurantWidget/utilities/helper/helper";
import { getOrderHistory } from "../../../../RestaurantWidget/utilities/api/restaurantsService";
import moment from "moment";
import IMAGE_PLACEHOLDER from "../../../assets/images/Images/empty-placeholder.png"
import MenuNavbarMini from "../../../components/Navbar/MenuNavbarMini";
import MenuFooter from "../../../components/Footer/MenuFooter/MenuFooter";
import MenuFooterMini from "../../../components/Footer/MenuFooter/MenuFooterMini";
import CustomInput from "../../../components/CustomInput/CustomInput";
import search from "../../../assets/search-v2.svg"
import close from "../../../assets/close.svg"
import download from "../../../assets/download-svgrepo-com.svg"
import CustomDropdown from "../../../components/CustomDropdown/CustomDropdown";
import filter from "../../../assets/filter.svg"
import clock from "../../../assets/clock-five.svg"
import calendar from "../../../assets/calendar.svg"
import { useHistory } from "react-router";
import config from "react-global-configuration";
import { useSelector } from "react-redux";



const HospitalityV2HistoryPage = () => {
    const sortOptions = [
        { label: "All Orders", value: "all" },
        { label: "Newest", value: "newest" },
        { label: "Oldest", value: "oldest" },
    ];
    const [data, setData] = useState([])
    const [itemsData, setItemsData] = useState([])

    const [value, setValue] = useState("")
    const [sort, setSort] = useState(sortOptions[0])
    const [isLoading, setIsLoading] = useState(true)
    const history = useHistory()
    const company = useSelector((state) => state.companyData.company);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        localStorage.removeItem("QUANTITY")
        localStorage.removeItem("ITEM")
        localStorage.removeItem("MODQUANTITY")
        const fetchData = async () => {
            const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
            const userID = localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_LOGGED_USER_ID) : localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
            getOrderHistory(val.cloudLocationID, userID).then((res) => {
                if (res) {
                    setItemsData(res)
                    setData([...res].reverse())
                    setIsLoading(false)
                } else {
                    setItemsData([])
                    setData([])
                    setIsLoading(false)
                }
            })

        }
        fetchData()
    }, [])
    useEffect(() => {
        if (sort.value === "oldest") {
            setData(itemsData)
        } else {
            setData([...itemsData].reverse())
        }
    }, [sort])
    useEffect(() => {
        if (value !== "") {
            const searchData = itemsData.filter((item) => item?.OrderID?.toString().toLowerCase().startsWith(value.toString().toLowerCase()))
            setData([...searchData].reverse())

        } else {
            setData([...itemsData].reverse())
        }
    }, [value])
    const getPrice = (
        basePrice
        , type
    ) => {
        let priceValue;
        switch (type) {
            case "DELIVERY_BY_REWARDCONSUMER":
                priceValue = basePrice.Delivery.FormattedText;
                break;
            case "DINE_IN":
                priceValue = basePrice.DineIn.FormattedText;
                break;
            case "TAKE_AWAY":
                priceValue = basePrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = basePrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }
    const renderModifierGroups = (selectedGroup) => {
        return (

            selectedGroup.SelectedItems.map((selectedItem, index) => (
                <span key={index}>
                    <span className="addon-title">
                        {selectedItem.Title.toLowerCase().replace(/\.+$/, '')} ({getPrice(selectedItem.PriceInfo.BaseTotalPrice)})
                    </span>
                    {selectedItem.SelectedModifierGroups && selectedItem.SelectedModifierGroups.length > 0 && (
                        <span>
                            {selectedItem.SelectedModifierGroups.map((nestedGroup, nestedIndex) => (
                                <span key={nestedIndex}> {renderModifierGroups(nestedGroup)}</span>
                            ))}
                        </span>
                    )}
                    {index < selectedGroup.SelectedItems.length - 1 && <span>, </span>}
                </span>
            ))

        );
    };
    const getTimeEstimation = (orderTrackingData, status) => {
        let esitimation;
        switch (status) {
            case "CREATED":
                esitimation = {
                    time: moment(new Date(orderTrackingData.CreatedTime)).format('HH:mm A'),
                    date: moment(new Date(orderTrackingData.CreatedTime)).format('YYYY-MM-DD')
                };
                break;
            case "PREPARING":
                esitimation = {
                    time: moment(new Date(orderTrackingData.PreparationTime.ReadyForPickupTime)).format('HH:mm A'),
                    date: moment(new Date(orderTrackingData.PreparationTime.ReadyForPickupTime)).format('YYYY-MM-DD'),
                };
                break;
            case "SCHEDULED":
                esitimation = {
                    time: moment(new Date(orderTrackingData.ScheduledOrderTargetDeliveryTimeRange.EndTime)).format('HH:mm A'),
                    date: moment(new Date(orderTrackingData.ScheduledOrderTargetDeliveryTimeRange.EndTime)).format('YYYY-MM-DD')
                }
                break;
            case "FINISHED":
                esitimation = {
                    time: moment(new Date(orderTrackingData.CompletedTime)).format('HH:mm A'),
                    date: moment(new Date(orderTrackingData.CompletedTime)).format('YYYY-MM-DD')
                }
                break;
            default:
                esitimation = {
                    time: moment(new Date(orderTrackingData.CreatedTime)).format('HH:mm A'),
                    date: moment(new Date(orderTrackingData.CreatedTime)).format('YYYY-MM-DD')
                }
                break;
        }
        return esitimation
    }

    return (
        <div className='HospitalityDefaultOrderPageV2'
            style={{ backgroundColor: config.get('Theme') === 'Hospitality-Default-V3-REGAL' ? company?.Style?.BackgroundColor : "" }}
        >
            <MenuNavbarMini />
            <div className="order-cont-wrap">
                {isLoading ?
                    <div className="loader-cont">
                        <div className="loader-lay" /></div>
                    : <>  <div className="order-history-page-cont">
                        <div className="order-history-header">
                            <div className="order-history-header-text">Order History</div>
                            {itemsData.length > 0 && <div className="order-history-header-right">
                                <div className="search-container-re">
                                    <div className="search-container-re-left">
                                        <img alt="" src={search} className="seacrh-ico" />
                                        <input
                                            value={value}
                                            onChange={(e) => {
                                                setValue(e.target.value)
                                            }}
                                            placeholder="Search orders..." />
                                    </div>

                                    {value !== "" && <img alt="" src={close} className="close-ico"
                                        onClick={() => {
                                            setValue("")
                                        }} />}

                                </div>
                                <div className="export-btn">
                                    <img alt="" src={download} className="dwn-ico" />
                                    Export
                                </div>
                            </div>}
                        </div>
                        {itemsData.length > 0 && <div className="order-bottm">
                            <div className="filter-cont">
                                <img alt="" src={filter} className="filter-ico" />

                                <CustomDropdown items={sortOptions} selected={sort}
                                    setSelected={setSort}
                                    showSortText={false} />
                            </div>
                            <div className="order-bottm-text">Showing {data.length} order(s)</div>
                        </div>}
                    </div>
                        {data.length > 0 ? data.map((order, key) => {
                            return (
                                <div className="order-history-page-cont" key={key}>
                                    <div className="order-container-header">
                                        <div className="order-container-header-left">
                                            <div className="order-id-det">
                                                <div className="order-id-det-text">Order {order?.OrderID}</div>
                                                <div className="order-id-det-status">{order?.State.toLowerCase()}</div></div>
                                            <div className="order-container-btm">
                                                <div className="order-container-btm-text">
                                                    <img alt="" src={calendar} className="cal-ico" />{getTimeEstimation(order, order.State).date}</div>
                                                <div className="order-container-btm-text">
                                                    <img alt="" src={clock} className="clock-ico" />{getTimeEstimation(order, order.State).time}</div>
                                            </div>

                                        </div>
                                        <div className="order-container-header-right">
                                            <div className="amount-header">Total Amount</div>
                                            <div className="amount-text">{order?.Payment?.PaymentDetail?.
                                                OrderTotal.Net.Formatted}</div>
                                        </div>
                                    </div>
                                    <div className="order-items">

                                        {order.Carts.Items.map((item) => {
                                            return (
                                                <div className="items-list-container">
                                                    <div className="items-list-container-left">
                                                        <div className="image-container">
                                                            <img alt="" src={item.PictureURL !== "" ? item.PictureURL : IMAGE_PLACEHOLDER} className="image-div" />
                                                        </div>
                                                        <div className="item-details">
                                                            <div className="item-details-left">

                                                                <div className="name">{item.Title}</div>
                                                                <div className="des-val">{item.SelectedModifierGroups.map((selectedGroup, index) => (
                                                                    <span key={index}> {renderModifierGroups(selectedGroup)} </span>
                                                                ))}</div>
                                                                <div className="qty">Quantity: {item.Quantity.Amount}</div>
                                                            </div>
                                                            <div className="item-details-right">
                                                                <div className="price">{getPrice(item.PriceInfo.BaseUnitPrice, value.FulfillmentType)}</div>
                                                                <div className="price-text">per item</div>
                                                            </div>  </div>
                                                    </div>

                                                </div>
                                            )
                                        })}
                                    </div>
                                    <div className="view-det">View Details</div>

                                </div>
                            )
                        })
                            : value === "" ? <div className="order-history-page-cont">
                                <div className="empty-history">
                                    <div className="empt-hdr">No Orders Yet</div>
                                    <div className="empt-sub-hdr">Looks like you haven’t placed any orders. When you're ready, we’ll be here!</div>
                                    <div className="empt-rst-btn"
                                        onClick={() => {
                                            history.push("")
                                        }}>Order Now
                                    </div>
                                </div>
                            </div> : <div className="order-history-page-cont">
                                <div className="empty-history">
                                    <div className="empt-hdr">No Matching Order</div>
                                    <div className="empt-sub-hdr">The entered ID doesn't match any existing orders. Please verify and enter the correct Order ID.</div>
                                    <div className="empt-rst-btn"
                                        onClick={() => {
                                            history.push("")
                                        }}>Order Now
                                    </div>
                                </div>
                            </div>

                        }</>}
            </div>
            <MenuFooter />
        </div >

    )
}
export default HospitalityV2HistoryPage